/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import CurrencyIcon from '../../../components/CurrencyIcon';
import { currencies, exchange } from '../../../utilities/constants';
import { featuresScreens, mainStakingCurrency } from '../constants';
import { formatNumber, formatNumberWithComma } from '../../../utilities/formatHelpers';

const StakingItemLayout = ({ item }) => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const detailsHandler = () => {
    history.push('/dashboard/staking/features', {
      initScreen: featuresScreens.STAKING_DEAL_DETAILS,
      dealId: item.id,
    });
  };

  const details = (
    <button
      type="button"
      className="btn text-btn-item text-f6 py-2 px-0 border-0 text-bolder text-primary"
      onClick={detailsHandler}>
      <b>{translate('details_button_title')}</b>
    </button>
  );

  const completedDays = useMemo(() => {
    if (item) {
      const currentDate = moment();
      const dealStartingDate = moment(item?.created_at);
      return currentDate.diff(dealStartingDate, 'days');
    }
    return 0;
  }, [item]);

  return (
    <div
      className="row bg-lighter rounded-extra px-md-4 px-3 py-3 my-3 mx-2 mx-md-0"
      role="button"
      onClick={isMobile ? detailsHandler : () => {}}
      onKeyDown={isMobile ? detailsHandler : () => {}}
      tabIndex={-1}>
      <div className="col-6 col-md-2 my-auto ps-0">
        <div className="d-flex flex-row justify-content-start align-items-center">
          <CurrencyIcon
            currencyCode={mainStakingCurrency}
            className="me-2"
            style={{ height: '1.6rem', width: '1.6rem' }}
          />
          <div className="d-flex flex-column">
            <p className="text-f5 text-dark">{mainStakingCurrency.toUpperCase()}</p>
            <p className="text-f6 text-shadow d-none d-md-block">
              {currencies[mainStakingCurrency].fullName}
            </p>
            <p className="text-f6 d-block d-md-none">
              <span className="text-shadow">{translate('create_staking_apr_label')}</span>
              <span className="text-success">{` ${item?.interest_apr}%`}</span>
            </p>
          </div>
        </div>
      </div>
      <div className="col-6 col-md-3 my-auto ps-0 text-f5 text-right text-md-start">
        <p className="text-dark">{`${formatNumberWithComma(
          formatNumber(
            item?.amount * currencies[mainStakingCurrency].conversion,
            exchange.CRYPTO_VALUE
          )
        )} ${mainStakingCurrency.toUpperCase()}`}</p>
      </div>
      <div className="col my-auto ps-2 d-none d-md-block pe-0">
        <p className="text-success text-f5">{`${item?.interest_apr}%`}</p>
      </div>
      <div className="col my-auto ps-0 d-none d-md-block">
        <p className="text-f5">
          <span className="text-dark">{`${
            completedDays > item?.duration_in_days ? item?.duration_in_days : completedDays
          } `}</span>
          <span className="text-shadow">{`/ ${item?.duration_in_days}`}</span>
        </p>
        <div className="progress bg-shadow mt-2">
          <div
            className="progress-bar bg-dark"
            style={{
              width: `${(completedDays * 100) / item?.duration_in_days}%`,
            }}
          />
        </div>
      </div>
      <div className="col d-md-block d-none text-end my-auto pe-0 d-none d-md-block">{details}</div>
    </div>
  );
};

export default StakingItemLayout;

StakingItemLayout.propTypes = {
  item: PropTypes.object.isRequired,
};
